var React = require('react');

function CalenderV2 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M26.666 3.99967H25.3327V1.33301H22.666V3.99967H9.33268V1.33301H6.66602V3.99967H5.33268C3.86602 3.99967 2.66602 5.19967 2.66602 6.66634V27.9997C2.66602 29.4663 3.86602 30.6663 5.33268 30.6663H26.666C28.1327 30.6663 29.3327 29.4663 29.3327 27.9997V6.66634C29.3327 5.19967 28.1327 3.99967 26.666 3.99967ZM26.666 27.9997H5.33268V13.333H26.666V27.9997ZM26.666 10.6663H5.33268V6.66634H26.666V10.6663Z","fill":"black"}));
}

CalenderV2.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = CalenderV2;

CalenderV2.default = CalenderV2;
